import ReactDOM from 'react-dom/client';

import App from './app/index';
import 'assets/style/style.scss';
import 'assets/style/fonts.scss';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(<App />);
